import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"

import type { OnboardingLockTarget } from "./map-quiz-to-target"

/** Independent of palmistry 10‑min / report-unlock 10‑min timers. */
export const ONBOARDING_LOCK_DURATION_MS = 30 * 60 * 1000

interface OnboardingLockState {
  /** Epoch ms when the lock started; null = never started. */
  startedAt: number | null
  target: OnboardingLockTarget | null
  /** True after Leave a review — unlocks immediately and stays unlocked. */
  skipped: boolean
  start: (target: OnboardingLockTarget) => void
  skip: () => void
}

export const useOnboardingLockStore = create<OnboardingLockState>()(
  persist(
    (set, get) => ({
      startedAt: null,
      target: null,
      skipped: false,
      start: (target) => {
        const state = get()
        if (state.skipped || state.startedAt !== null) return
        set({ startedAt: Date.now(), target })
      },
      skip: () => set({ skipped: true }),
    }),
    {
      name: "onboarding_lock",
      storage: createJSONStorage(() => localStorage),
    },
  ),
)

export function skipOnboardingLock(): void {
  useOnboardingLockStore.getState().skip()
}

export function remainingOnboardingLockMs(
  startedAt: number | null,
  skipped: boolean,
  now = Date.now(),
): number {
  if (skipped || startedAt === null) return 0
  return Math.max(0, startedAt + ONBOARDING_LOCK_DURATION_MS - now)
}

export function formatOnboardingLockLabel(remainingMs: number): string {
  const totalSeconds = Math.ceil(remainingMs / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${seconds.toString().padStart(2, "0")}`
}
